import { render } from "./MerchantOrdersList.vue?vue&type=template&id=10b78178"
import script from "./MerchantOrdersList.vue?vue&type=script&lang=js"
export * from "./MerchantOrdersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__